import { PUBLIC_URL } from "configs/configs";
import { TEXT_VARIABLES_EOY_PSH_2022 } from "./texts";

export const createJsonData = (projectName: string, id: string): string => `
{"images": [{"name": "img_0", "asset": "${PUBLIC_URL}/psh-eoy-2022/${projectName}/1.png"},{"name": "img_1","asset": "${PUBLIC_URL}/psh-eoy-2022/${projectName}/2.png"},{"name": "img_2","asset": "${PUBLIC_URL}/psh-eoy-2022/${projectName}/3.png"},{"name": "img_3","asset": "${PUBLIC_URL}/psh-eoy-2022/grupal.png"}],"texts": [{"_id": "1","name": "#s01_text01_c01","type": 1,"templateId": "1","ctaLink": "","value": "${
  TEXT_VARIABLES_EOY_PSH_2022[`${projectName}_${id}`].person
}"}]}`;
